<template>
  <article class="card-categ">
    <header class="img">
      <img class="block h-auto w-full" :src="imgSrc" />
    </header>
    <footer class="detail-card-categ">
      <Tag :text="tag" :color="color" :bgColor="bgColor" />
      <h1>{{ title }}</h1>
      <p>
        {{ content }}
      </p>
    </footer>
  </article>
</template>
<script>
import Tag from '@/components/primitive/Tag'
export default {
  props: {
    color: String,
    bgColor: String,
    tag: String,
    imgSrc: String,
    title: String,
    content: String
  },
  components: {
    Tag
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
/deep/.ant-tag{
  @apply mt-2 mb-4;
  border-radius: 8px;
  @media (max-width:768px) {
    @apply mt-0 mb-4;
  }
}
</style>
